const getDurationStr = (videoDuration, isVideoDurationInSeconds = false) => {
  const divider = isVideoDurationInSeconds ? 3600 : 60;
  let durationStr = '';
  if (videoDuration) {
    const hrs = videoDuration / divider;
    const hours = Math.floor(hrs);
    const minutes = Math.round((hrs - hours) * 60);
    if (hours > 0) {
      durationStr += `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
    }
    if (minutes > 0) {
      durationStr += ` ${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
    }
  }
  return durationStr;
};

export default getDurationStr;
